export const getStore = state => state.monitoredDocumentChanges || {};

export const getMonitoredDocumentChanges = state => getStore(state).monitoredDocumentChanges || [];
export const getPaging = state => getStore(state).paging;

export const isFetching = state => getStore(state).fetching;
export const isFetched = state => getStore(state).fetched;
export const hasFailed = state => getStore(state).failed;
